import React from "react";
import { CodeResponse, useGoogleLogin } from "@react-oauth/google";
import GoogleLoginButton from "./GoogleLoginButton/GoogleLoginButton";
import { useTranslation } from "react-i18next";
import { useGoogleConnect } from "../queries/google";

interface GoogleCalendarLoginProps {
  onConnectSuccessful: () => void;
}

const GoogleCalendarLogin = ({
  onConnectSuccessful,
}: GoogleCalendarLoginProps) => {
  const { t } = useTranslation();
  const { mutate: googleConnect } = useGoogleConnect({ onConnectSuccessful });

  const onSuccess = async (codeResponse: CodeResponse) => {
    const authCode = codeResponse.code;

    googleConnect({ authCode });
  };

  const onFailure = () => {
    console.error(t("utility-panel.cant-login"));
  };

  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: onSuccess,
    onError: onFailure,
    scope: "https://www.googleapis.com/auth/calendar openid",
  });

  return (
    <div>
      <GoogleLoginButton onClick={() => googleLogin()} />
    </div>
  );
};

export default GoogleCalendarLogin;
